import { memo } from "react"

import { SeparatorMessage } from "./separatorMessage"

export default memo(SeparatorMessage)
